module.exports = __webpack_public_path__ + "img/e440f44.png";